import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends ApiBaseService {
  loginWithCode(
    code: string,
  ): Observable<{ access_token: string; middleware_token: string }> {
    return this.post<{ access_token: string; middleware_token: string }>(
      '/auth/client-login-with-code',
      { code },
    ).pipe(
      tap((response) => {
        sessionStorage.setItem('access_token', response.access_token);
        sessionStorage.setItem('middleware_token', response.middleware_token);
        sessionStorage.setItem('verification_code', code);
      }),
    );
  }

  getAccessToken(): string | null {
    return sessionStorage.getItem('access_token');
  }

  getMiddlewareToken(): string | null {
    return sessionStorage.getItem('middleware_token');
  }

  getVerificationCode(): string | null {
    return sessionStorage.getItem('verification_code');
  }

  isAuthenticated(): boolean {
    return !!this.getAccessToken();
  }

  logout(): void {
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('middleware_token');
    sessionStorage.removeItem('verification_code');
  }
}
